import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  dock: {
    position: 'absolute',
    left: '100%',
    top: 0,
    height: '100%',
  },
}))
